import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import {  Validators } from '@angular/forms';
import { Posao } from './posao';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-posao-update',
  templateUrl: './posao-update.component.html',
  
})
export class PosaoUpdateComponent extends BaseUpdateComponent<Posao> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService

  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
   }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'NACIJA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Opis", Validators.maxLength(100), 'maxlength', 'NACIJA.NAZIV.VALIDATION.MAXLENGTH');
  }

}
